import React from 'react';

class FormatoSimplificado1347567PlanGoldPlusS_pdf extends React.Component {
    componentDidMount() {
        let event = new Event('js');
        window.dispatchEvent(event);
        document.title = 'Red Itmex - Documentacion - Formato Simplificado 1347567 Plan Gold + SIMÉTRICO';
        this.abrirPdf()
    }
    abrirPdf = () => {
        window.location.href = 'https://firebasestorage.googleapis.com/v0/b/reditmextrescero.appspot.com/o/datasheets%2Flegal%2FITMEX_FORMATO_SIMPLIFICADO_1347567_GOLD%2BS_2024_V1.pdf?alt=media&token=13d69e53-0202-4457-82fd-84c2f1d71ff7';
    }
    render() {
        return (
            <div>Loading...</div>
        )
    }
}
export default FormatoSimplificado1347567PlanGoldPlusS_pdf